import React from "react";
import Modal from "../../../../elements/Modal";
import ManageCategory from "../ManageCategory";

const ManageCategoryModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl4"
      title={data?._id ? "Update One" : "Create New"}
    >
      <ManageCategory getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageCategoryModal;
